import React from 'react';
import Button3D from '../ui/Button3D';
import NotificationPopup from './NotificationPopup';

// BL-177 Step 2o (section 4): the in-app pop-ups, stacked. Newest card on top; at most three show, the rest are "+N more" (a 3D button
// that opens the bell, where every alert still is). Each card is the same raised 3D card as before (NotificationPopup, `stacked`) with
// its own Open / Reply / × and its own timeout; a card that holds several messages from one conversation says so in its title.
// `entries` = [{ id, version, view }] for the visible cards, newest first (see src/lib/notificationPopupStack.js).
export default function NotificationPopupStack({ entries = [], hiddenCount = 0, onOpen, onReply, onDismiss, onOpenMessage, onMore }) {
    if (!entries.length) return null;
    return (
        <div
            className="fixed bottom-4 right-4 z-50 flex w-[min(26rem,calc(100vw-2rem))] flex-col gap-2"
            data-testid="notification-popup-stack"
            role="region"
            aria-label="New notifications"
        >
            {entries.map(({ id, version, view }) => (
                <NotificationPopup
                    key={id}
                    stacked
                    timerKey={`${id}:${version}`}
                    view={view}
                    onOpen={() => onOpen?.(id)}
                    onReply={() => onReply?.(id)}
                    onDismiss={() => onDismiss?.(id)}
                    onOpenMessage={(key) => onOpenMessage?.(id, key)}
                />
            ))}
            {hiddenCount > 0 && (
                <div className="flex justify-end">
                    <Button3D variant="pill" data-testid="popup-more" onClick={onMore}>+{hiddenCount} more</Button3D>
                </div>
            )}
        </div>
    );
}
